import React from 'react';
import ErrorScreen, {
  KINDS,
} from '@gcloud-npm/next12.app-controller.error-screen';


const E500 = () => {
  return (
    <>
      <ErrorScreen kind={KINDS.E500} />
    </>
  );
};


export default E500;
